import Typography from '@material-ui/core/Typography';
import React from 'react';
import BirthdayDay from './BirthdayDay';
import BirthdayMonth from './BirthdayMonth';

export default function BirthdayDetails() {
  return (
    <>
      <div className="flex flex-col border-solid border-4 border-light-blue-500 h-screen justify-items-end  w-full md:w-1/2 lg:w-1/3 ">
        {/* <div
          className="border-solid mb-2 border-light-blue-500 text-center text-blue accordion p-4 font-black bg-blue-500"
          style={{ backgroundColor: '#1ab394', color: '#FFF' }}
        >
          <Typography variant="h6">Aniversariantes</Typography>
        </div> */}
        <div
          style={{
            backgroundColor: '#fff',
            width: '100%',
            height: '90vh',
            overflowY: 'scroll',
          }}
        >
          <div
            style={{
              backgroundColor: '#1ab394',
              color: '#FFF',
              width: '100%',
              height: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h6">Hoje</Typography>
          </div>
          <div>
            <BirthdayDay />
          </div>

          <div
            style={{
              backgroundColor: '#1ab394',
              color: '#FFF',
              width: '100%',
              height: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h6">Mês</Typography>
          </div>

          <BirthdayMonth />
        </div>
      </div>
    </>
  );
}
